import { useEffect, useRef } from 'react';
import { supabase } from '../lib/supabase';

/**
 * Hook do okresowego sprawdzania i aktualizacji statusu wydarzeń
 * Wywołuje funkcję bazy danych process_event_statuses_and_notifications
 * co minutę, jeśli użytkownik jest zalogowany
 */
export function useEventStatusChecker(userId) {
  const intervalRef = useRef(null);

  useEffect(() => {
    if (!userId) {
      return;
    }

    // Wywołaj funkcję natychmiast przy montowaniu
    const checkEventStatuses = async () => {
      try {
        const { error } = await supabase.rpc('process_event_statuses_and_notifications');

        if (error) {
          if (error.message && (error.message.includes('function') || error.message.includes('does not exist'))) {
            return;
          }
          console.error('[EventStatusChecker] Error checking event statuses:', error.message || error);
        }
      } catch (err) {
        if (err.message && (err.message.includes('function') || err.message.includes('does not exist'))) {
          return;
        }
        console.error('[EventStatusChecker] Error in event status checker:', err.message || err);
      }
    };

    // Wywołaj natychmiast
    checkEventStatuses();

    // Ustaw interwał na co 5 minut (300000 ms) - zmniejszona częstotliwość aby uniknąć spamu
    // W produkcji zalecane jest użycie Supabase Edge Function lub cron job
    intervalRef.current = setInterval(checkEventStatuses, 300000);

    // Cleanup
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [userId]);
}
